import { NavigationButton } from "@components/common/NavigationLink";
import {
  FormatListBulleted,
  HourglassEmpty,
  RemoveCircleOutline,
  ReportGmailerrorred,
} from "@mui/icons-material";
import { RoutePaths } from "@utils/constants/routes";
import { useTranslation } from "react-i18next";

import LinksSubHeader from "..";

function DriverSubHeader() {
  const { t } = useTranslation();
  return (
    <LinksSubHeader>
      <NavigationButton
        to={RoutePaths.adminDriversTableacceptedRequests}
        includes={RoutePaths.acceptedRequests}
      >
        <FormatListBulleted />
        <span style={{ fontSize: "0.75rem" }}>{t("layouts.sub-headers.drivers.accepted")}</span>
      </NavigationButton>

      <NavigationButton
        to={RoutePaths.adminDriversTableWaitingRequests}
        includes={RoutePaths.waitingRequests}
      >
        <HourglassEmpty />
        <span style={{ fontSize: "0.75rem" }}>{t("layouts.sub-headers.drivers.demandes")}</span>
      </NavigationButton>

      <NavigationButton
        to={RoutePaths.adminDriversTablerefusedRequests}
        includes={RoutePaths.refusedRequests}
      >
        <ReportGmailerrorred />
        <span style={{ fontSize: "0.75rem" }}>{t("layouts.sub-headers.drivers.rejected")}</span>
      </NavigationButton>
      <NavigationButton
        to={RoutePaths.adminDriversTabledisabledDrivers}
        includes={RoutePaths.disabledDrivers}
      >
        <RemoveCircleOutline />
        <span style={{ fontSize: "0.75rem" }}>{t("layouts.sub-headers.drivers.banned")}</span>
      </NavigationButton>
    </LinksSubHeader>
  );
}

export default DriverSubHeader;
